import type {
	JiraApprovedProject,
	JiraConnection,
	JiraProjects,
	JiraSiteProject,
	JiraWorkHealth,
} from "@/types/api";
import { http } from "./http";

export const jiraService = {
	getConnection: (signal?: AbortSignal) =>
		http.get<JiraConnection>("/api/org/integrations/jira", { signal }),
	startConnection: (siteUrl: string) =>
		http.post<{ url: string }>("/api/org/integrations/jira/connect", {
			siteUrl,
		}),
	disconnect: () => http.del<void>("/api/org/integrations/jira"),
	getProjects: (signal?: AbortSignal) =>
		http.get<JiraProjects>("/api/org/integrations/jira/projects", { signal }),
	getWorkHealth: (signal?: AbortSignal) =>
		http.get<JiraWorkHealth>("/api/org/integrations/jira/work-health", {
			signal,
		}),
	/** Replaces the whole approved list: every project that should stay approved, or [] to remove them all. */
	setApprovedProjects: (projects: Pick<JiraSiteProject, "id" | "name">[]) =>
		http.put<{ projects: JiraApprovedProject[] }>(
			"/api/org/integrations/jira/approved-projects",
			{
				projects: projects.map(({ id, name }) => ({
					id,
					name,
					orgVisible: true,
				})),
			},
		),
};
